import React, {createContext, useEffect, useState} from "react";

export const ShopContext = createContext(null);

const getDefaultCart = ()=>{
        let cart = {};
        for(let index = 0; index<=300; index++){
            cart[index] = 0;
        }
        return cart;
    }

const ShopContextProvider = (props) => {

    const [all_products, setAll_products] = useState([]);

    const [cartItems, setCartItems] = useState(getDefaultCart());

    useEffect(()=>{
        fetch('https://drapify-backend.onrender.com/allproducts')
        .then((response)=>response.json())
        .then((data)=>setAll_products(data))

        if(localStorage.getItem('auth-token')){
            fetch('https://drapify-backend.onrender.com/getcart', {
                method: 'POST',
                headers:{
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem('auth-token')}`,
                    'Content-Type': 'application/json'
                },
                body:""
            }).then((response)=>response.json())
            .then((data)=>setCartItems(data));
        }
    }, [])

    const addToCart = (itemId) => {
        setCartItems((prev)=>({...prev,[itemId]:prev[itemId]+1}));
        if(localStorage.getItem('auth-token')){
            fetch('https://drapify-backend.onrender.com/addtocart', {
                method: 'POST',
                headers:{
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem('auth-token')}`,
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({'itemId':itemId}),
            })
            .then((response)=>response.json())
            .then((data)=>setCartItems((prev)=>({...prev, data})));
        }
    }

    const removeFromCart = (itemId) => {
        setCartItems((prev)=>({...prev,[itemId]:prev[itemId]-1}))
         if(localStorage.getItem('auth-token')){
            fetch('https://drapify-backend.onrender.com/removefromcart', {
                method: 'POST',
                headers:{
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem('auth-token')}`,
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({'itemId':itemId}),
            })
            .then((response)=>response.json())
            .then((data)=>setCartItems((prev)=>({...prev, data})));
        }
    }

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for(const item in cartItems){
            if(cartItems[item]>0){
                let itemInfo = all_products.find((product)=>
                    product.id===Number(item)
                )
                totalAmount += itemInfo.new_price * cartItems[item];
            }
        }
        return totalAmount;
    }

    const getTotalCartItems = ()=>{
        let totalItems = 0;
        for(const item in cartItems){
            totalItems += cartItems[item];
        }
        return totalItems;
    }

    const contextValue = { getTotalCartItems, getTotalCartAmount, all_products, cartItems, addToCart, removeFromCart}

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    )
}

export default ShopContextProvider